import {
  ICallcardButtonEvent,
  ICallcardButtonTool,
  ToolColor,
  ToolExpand,
  ToolFill,
  ToolSize,
  ToolType
} from '@addins/core/singlecallcard';
import { Observable, Subject } from 'rxjs';

export class EngagementCardButton implements ICallcardButtonTool {
  readonly ENGAGE_TITLE: string = 'Mobile.Engage';

  private readonly _click = new Subject<ICallcardButtonEvent>();
  get onClick(): Observable<ICallcardButtonEvent> {
    return this._click.asObservable();
  }

  readonly icon: string = 'play-circle-outline';
  position: number = 100;
  show: boolean;
  text: string = this.ENGAGE_TITLE;
  dontTranslate: boolean = false;
  type: ToolType;

  color: ToolColor;
  expand: ToolExpand;
  fill: ToolFill;
  size: ToolSize;

  click(): void {
    this._click.next();
  }
}
